"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var CatSpecials32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16.43 23.902l6.387 3.449c.491.265.811.039.721-.5l-1.225-7.338a1.08 1.08 0 01.27-.852l5.179-5.185c.386-.386.261-.77-.286-.851l-7.14-1.065a1.04 1.04 0 01-.706-.527l-3.201-6.66c-.238-.496-.629-.5-.869 0l-3.201 6.66a1.042 1.042 0 01-.707.527l-7.141 1.065c-.549.082-.673.462-.285.851l5.179 5.185c.199.199.316.576.27.852L8.45 26.851c-.088.527.232.764.721.5l6.387-3.449a1.02 1.02 0 01.872 0zM9.645 28.23c-1.213.656-2.409-.188-2.182-1.544l1.225-7.337c.001.012-5.17-5.166-5.17-5.166-.97-.971-.514-2.345.845-2.547l7.141-1.065c-.04.01 3.153-6.631 3.153-6.631.604-1.255 2.07-1.251 2.672 0l3.2 6.66c-.018-.027 7.094 1.037 7.094 1.037 1.355.202 1.812 1.579.846 2.547l-5.18 5.184c.01-.013 1.234 7.318 1.234 7.318.229 1.368-.967 2.201-2.182 1.544l-6.387-3.447c.046.021-6.309 3.447-6.309 3.447z" }))); };
var StyledCatSpecials32 = styled_components_1.default(CatSpecials32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatSpecials32;
var templateObject_1;
//# sourceMappingURL=CatSpecials32.js.map